var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("DisputeDialog.dispute_invoice"),
        visible: _vm.visible,
        "before-close": _vm.handleClose,
        width: "520px"
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, "label-position": "top", rules: _vm.rules }
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "dispute_code",
                label: _vm.$t("DisputeDialog.dispute_code")
              }
            },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t("DisputeDialog.dispute_code") },
                  on: { change: _vm.onDisputeCodeChange },
                  model: {
                    value: _vm.form.dispute_code,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "dispute_code", $$v)
                    },
                    expression: "form.dispute_code"
                  }
                },
                _vm._l(_vm.sortedDisputeCodes, function(dispute_code) {
                  return _c("el-option", {
                    key: dispute_code.reference,
                    attrs: {
                      label: _vm.$translate.dispute_code(dispute_code.code),
                      value: dispute_code.reference
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("DisputeDialog.note") } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 2,
                  placeholder: _vm.$t("DisputeDialog.note")
                },
                model: {
                  value: _vm.form.note,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "note", $$v)
                  },
                  expression: "form.note"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("DisputeDialog.assignee") } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t("DisputeDialog.assignee") },
                  model: {
                    value: _vm.form.assignee,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "assignee", $$v)
                    },
                    expression: "form.assignee"
                  }
                },
                [
                  _c("el-option", {
                    key: "unassigned",
                    attrs: { label: "Niemand", value: "unassigned" }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.participantUsers, function(user) {
                    return _c("el-option", {
                      key: user.person_by_reference.reference,
                      attrs: {
                        label: user.person_by_reference.username,
                        value: user.person_by_reference.reference
                      }
                    })
                  })
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("DisputeDialog.days_to_suspend") } },
            [
              _c("el-input", {
                attrs: {
                  type: "number",
                  min: "0",
                  max: _vm.maxDaysToSuspend,
                  value: _vm.form.days_to_suspend,
                  placeholder: _vm.$t("DisputeDialog.days_to_suspend")
                },
                on: { input: _vm.handleDaysToSuspendInput }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("shared.Cancel")))
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { loading: _vm.loading, type: "primary" },
              on: { click: _vm.onSubmit }
            },
            [_vm._v(_vm._s(_vm.$t("shared.Confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }